import axios from "axios";
import { del, get, post, patch,  put } from "./features_api_helper";
import * as url from "./features_url_helper";





// Get features
export const getFeatures = () => get(url.GET_FEATURES);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_FEATURE, feature);
export const addNewFeature = feature => post(url.ADD_NEW_FEATURE, {feature});


// update feature
//export const updateFeature = feature => put(url.UPDATE_FEATURE, feature);
export const updateFeature = feature => patch(`${url.UPDATE_FEATURE}/${feature.uid}`,   { feature  });


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_FEATURE, { headers: { feature } });
export const deleteFeature = feature => del(`${url.DELETE_FEATURE}/${feature}`);







export {
  //getLoggedInUser,
  
  
};
